import { useMutation } from "@tanstack/react-query";
import { useParams } from "react-router-dom";
import { useAlert } from "contexts/alert";
import api from "services/api";

import { IPerson } from "../Adesoes.types";

function useSaveAdesao() {
    const { organizationId, contractId } = useParams() as { organizationId: string, contractId: string };
    const { openAlert } = useAlert();
    
    const { isSuccess, isPending, isError, mutate } = useMutation({
        mutationFn: async (payload: IPerson[]) => {
            const modifiedData = payload.filter(person => person.wasModified === true);

            await api.post(`/apps/adesao/${organizationId}/${contractId}`, modifiedData);
        },
        onSuccess: () => {
            openAlert('Dados salvos com sucesso', 'success');
        },
        onError: (err) => {
            console.log("[Error @ useSaveAdesao]", err)
            openAlert('Algo deu errado ao salvar dados', 'error');
        },
    });

    return {
        isSuccessSave: isSuccess,
        isPendingSave: isPending,
        isErrorSave: isError,
        handleSaveAdesao: mutate 
    };
}

export { useSaveAdesao };
